

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';


import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';

@Injectable({
  providedIn: 'root'
})
export class UserpermissionService {
  private message: string;

  constructor(private _router: Router,private http: HttpClient ) {


   }

   roleList(obj:any):any{

    try{
    let httpOptions = {
    headers: new HttpHeaders({
    'Content-Type': 'application/json',
    "Authorization": "Bearer "+obj.token,
    
    })
    };
    
    let api_url =AppSettings.API_ENDPOINT+'role.php';
    
    return this.http.post<any>(api_url, obj,httpOptions);
    
    
    
    }catch(err){
    
    this._router.navigate(['/login']);
    
    }
    
    }


    savepermissionList(obj:any):any{

      try{
        let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
  
          })
        };
  
        let api_url =AppSettings.API_ENDPOINT+'role.php';
  
       return this.http.post<any>(api_url, obj,httpOptions);
  
  
  
      }catch(err){
  
        this._router.navigate(['/login']);
  
      }
  
    }


  permissionList(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'permission.php';

     return this.http.post<any>(api_url, obj,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }

}
